import { HttpClient, HttpEventType } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IUploadPosition } from '../models/upload-progress.model';
import { SpinnerService } from './spinner.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AwsService {

  constructor(
    private http: HttpClient,
    public spinnerService: SpinnerService,
    public toastService: ToastService
  ) { }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR uploadFile                             */
  /* -------------------------------------------------------------------------- */
  // region uploadFile
  /** Sube el blob a la liga prefirmada de S3 y publica en el spinner el nombre
      del archivo, su posición ("Archivo 2 de 5") y el porcentaje real.
      Si no se manda fileName y el blob es un File, se usa su name. */
  async uploadFile(
    uploadUrl: string,
    file: Blob,
    contentType: string,
    fileName?: string,
    position: IUploadPosition | null = null
  ): Promise<boolean> {

    console.log('uploadUrl', uploadUrl);
    console.log('file', file);

    let flag = false;

    const name = fileName ?? (
      file instanceof File ? file.name : 'Archivo'
    );

    this.spinnerService.loading = true;
    this.spinnerService.startUpload(name, position);

    try {

      const response = await new Promise<boolean>(
        (resolve, reject) => {
          this.http.put(
            uploadUrl,
            file,
            {
              headers: {
                'Content-Type': contentType
              },
              reportProgress: true,
              observe: 'events'
            }
          ).subscribe({
            next: (event) => {

              if (event.type === HttpEventType.UploadProgress) {

                const total = event.total ?? file.size;

                if (total > 0) {
                  this.spinnerService.setUploadPercent(
                    (event.loaded / total) * 100
                  );
                }

              } else if (event.type === HttpEventType.Response) {

                console.log(event);

                this.spinnerService.setUploadPercent(100);
                resolve(true);

              }

            },
            error: (error) => {
              console.error(error);
              if (error.error) {
                resolve(false);
              } else {
                this.toastService.show({
                  header: 'Error de servidor',
                  body: `${error}`,
                  classname: 'bg-danger text-white'
                });
                reject(false);
              }
            }
          });
        }
      );

      flag = response;

    } catch (error) {
      console.log(error);
      this.toastService.show({
        header: 'Error',
        body: `${error}`,
        classname: 'bg-danger text-white'
      });
    }

    finally {
      this.spinnerService.loading = false;
      this.spinnerService.message = '';
      this.spinnerService.clearUpload();
    }

    return flag;

  }

}
